import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=78553b66&scoped=true&"
import script from "./MessageIndex.vue?vue&type=script&lang=js&"
export * from "./MessageIndex.vue?vue&type=script&lang=js&"
import style0 from "./MessageIndex.vue?vue&type=style&index=0&id=78553b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78553b66",
  null
  
)

export default component.exports